import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';
import buttonFields from '../helpers/buttonFields';
import commonFields from '../helpers/commonFields';

const Kremirani: IModel = {
  title: 'Kremirani',
  apiPath: 'groblja/kremirani',
  forms: {
    default: {
      fields: [
        'groblje_id',
        'registar_umrlih_id',
        'datum_kremiranja',
        'evidencijski_broj',
        'mjesto_kremiranja',
        'ugovoritelj_kremiranja',
        'preuzimatelj_posmrtnih_ostataka',
      ],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'groblje_id',
        'oib',
        'ime',
        'prezime',
        'prezime_ime',
        'datum_kremiranja',
        'evidencijski_broj',
        'mjesto_kremiranja',
        'ugovoritelj_kremiranja',
        'preuzimatelj_posmrtnih_ostataka',
        'docs',
        'btn_show_history',
      ],
      hidden: ['id', 'ime', 'prezime'],
    },
    history: {
      fields: [
        'id',
        'oib',
        'ime',
        'prezime',
        'prezime_ime',
        'datum_kremiranja',
        'evidencijski_broj',
        'mjesto_kremiranja',
        'ugovoritelj_kremiranja',
        'preuzimatelj_posmrtnih_ostataka',
        'docs',
        'edited',
      ],
      hidden: ['id', 'ime', 'prezime'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'registar_umrlih_id',
      source: 'registar_umrlih_id',
      ttoken: 'groblja:ukopani.registar_umrlih_neukopani',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/registar-umrlih?view=picker_neukopani',
        format: '{label}',
        idattr: 'id',
        additionalData: ['groblje_id'],
      },
      validation: {
        required: true
      },
      readonly: false,
      filter: true,
    },
    {
      type: 'boolean',
      source: 'has_history',
      title: 'has history',
      ttoken: 'common.has_history',
    },
    {
      title: 'oib',
      source: 'oib',
      ttoken: 'groblja:registar_umrlih.oib',
      type: 'text',
      filter: true,
    },
    {
      title: 'prezime_ime',
      source: 'prezime_ime',
      ttoken: 'groblja:registar_umrlih.prezime_ime',
      type: 'text',
      filter: true,
    },
    {
      title: 'ime',
      source: 'ime',
      ttoken: 'common.ime',
      type: 'text',
      filter: true,
    },
    {
      title: 'prezime',
      source: 'prezime',
      ttoken: 'common.prezime',
      type: 'text',
      filter: true,
    },
    {
      title: 'datum_kremiranja',
      source: 'datum_kremiranja',
      ttoken: 'groblja:kremirani.datum_kremiranja',
      type: 'date',
      filter: true,
    },
    {
      title: 'evidencijski_broj',
      source: 'evidencijski_broj',
      ttoken: 'groblja:kremirani.evidencijski_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'mjesto_kremiranja',
      source: 'mjesto_kremiranja',
      ttoken: 'groblja:kremirani.mjesto_kremiranja',
      type: 'text',
      filter: true,
    },
    {
      title: 'ugovoritelj_kremiranja',
      source: 'ugovoritelj_kremiranja',
      ttoken: 'groblja:kremirani.ugovoritelj_kremiranja',
      type: 'text',
      filter: true,
    },
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
      filter: true,
    },
    {
      title: 'preuzimatelj_posmrtnih_ostataka',
      source: 'preuzimatelj_posmrtnih_ostataka',
      ttoken: 'groblja:kremirani.preuzimatelj_posmrtnih_ostataka',
      type: 'text',
      filter: true,
    },
    {
      title: 'is_deleted',
      source: 'is_deleted',
      ttoken: '',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'edited',
      source: 'edited',
      ttoken: 'common.edited',
      type: 'datetime',
      filter: true,
    },
    {
      title: 'action',
      source: 'action',
      ttoken: 'common.action',
      type: 'picker',
      items: {
        labels: ['common.actions.update', 'common.actions.insert', 'common.actions.delete'],
        values: ['UPDATE', 'INSERT', 'DELETE'],
      },
      filter: true,
      translate: true,
      readonly: true,
    },
    coreFields.geom,
    coreFields.gid,
    commonFields.docsHistory,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
    buttonFields.show_history,
  ],
};

export default Kremirani;
